import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["datetimeSelect"]

  connect() {
    console.log("ICS Form Controller connected")
    if (this.isEmailTemplateBlock()) {
    this.setupFormSubmission()
    } else {
      console.log("ICS Form Controller: Not an email_template block, skipping validation setup")
    }
  }

  isEmailTemplateBlock() {
    const container = this.element
    if (!container) return false
    
    const form = container.closest('form')
    if (form) {
      const blockTypeField = form.querySelector('input[name*="[block_type]"], input[name*="block_type"]')
      if (blockTypeField) {
        const blockType = blockTypeField.value
        console.log(`ICS Form Controller: Block type is ${blockType}`)
        return blockType === 'email_template'
      }
    }
    return false
  }

  setupFormSubmission() {
    // Find the form that contains this controller
    const form = this.element.closest('form')
    if (form) {
      // Add event listener for form submission
      form.addEventListener('submit', (event) => {
        console.log("Form submission detected, validating ICS fields")
        if (!this.validateICSFields()) {
          event.preventDefault()
          return false
        }
        console.log("ICS validation passed, syncing slim-select values")
        this.syncSlimSelectValues()
      })
      
      // Also listen for form submit button clicks
      const submitButtons = form.querySelectorAll('input[type="submit"], button[type="submit"]')
      submitButtons.forEach(button => {
        button.addEventListener('click', (event) => {
          console.log("Submit button clicked, validating ICS fields")
          if (!this.validateICSFields()) {
            event.preventDefault()
            return false
          }
          console.log("ICS validation passed, syncing slim-select values")
          this.syncSlimSelectValues()
        })
      })
    }
  }

  validateICSFields() {
    if (!this.isEmailTemplateBlock()) {
      console.log("ICS validation skipped: Not an email_template block")
      return true
    }
    
    const container = this.element
    if (!container) {
      return true
    }
    
    const isVisible = container.offsetParent !== null && 
                     container.style.display !== 'none' && 
                     !container.classList.contains('hidden')
    if (!isVisible) {
      console.log("ICS validation skipped: Container is hidden")
      return true
    }
    
    const icsCheckbox = this.element.querySelector('#ics-checkbox')
    if (!icsCheckbox) {
      console.log("ICS validation skipped: ICS checkbox not found")
      return true
    }
    
    const datetimeSelect = this.element.querySelector('#ics-datetime-field_id')
    const validationError = this.element.querySelector('#ics-validation-error')
    
    if (icsCheckbox && icsCheckbox.checked) {
      // ICS is enabled, check if datetime field is selected
      if (!datetimeSelect || !datetimeSelect.value || datetimeSelect.value === '') {
        // Show validation error
        if (validationError) {
          validationError.style.display = 'block'
        }
        console.log("ICS validation failed: No datetime field selected")
        return false
      } else {
        // Hide validation error if it was showing
        if (validationError) {
          validationError.style.display = 'none'
        }
        console.log("ICS validation passed: Datetime field selected")
        return true
      }
    } else {
      // ICS is not enabled, validation passes
      if (validationError) {
        validationError.style.display = 'none'
      }
      console.log("ICS validation passed: ICS not enabled")
      return true
    }
  }

  syncSlimSelectValues() {
    // Find all slim-select elements within this controller and sync their values
    const selectElements = this.element.querySelectorAll('select.slim-select')
    selectElements.forEach(select => {
      if (select.slimSelectInstance) {
        // Get the selected value from slim-select
        const selectedValue = select.slimSelectInstance.getSelected()
        // Sync it back to the original select element
        if (selectedValue && selectedValue.length > 0) {
          select.value = selectedValue[0]
        } else {
          select.value = ""
        }
        console.log(`Synced slim-select value for ${select.name}: ${select.value}`)
      } else {
        console.log(`No slim-select instance found for ${select.name}`)
      }
    })
  }

  syncSlimSelect(event) {
    // This method is called when the slim-select changes
    const selectElement = event.target
    if (selectElement.slimSelectInstance) {
      // Get the selected value from slim-select
      const selectedValue = selectElement.slimSelectInstance.getSelected()
      // Sync it back to the original select element
      if (selectedValue && selectedValue.length > 0) {
        selectElement.value = selectedValue[0]
      } else {
        selectElement.value = ""
      }
      console.log(`Synced slim-select value for ${selectElement.name}: ${selectElement.value}`)
    }
  }
}
